import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd01fac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-sign" }
const _hoisted_2 = {
  key: 0,
  class: "sign-img normal",
  src: "/static/img/normal.webp",
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "sign-img greeting",
  src: "/static/img/greeting.webp",
  alt: ""
}
const _hoisted_4 = {
  key: 2,
  class: "sign-img blindfold",
  src: "/static/img/blindfold.webp",
  alt: ""
}
const _hoisted_5 = { class: "sign-oauth" }

import { computed, ref } from 'vue'
import { SignApi } from '.'
import formVue from './form.vue'
// import 'element-plus/es/components/button/style/css'


export default /*#__PURE__*/_defineComponent({
  __name: 'sign',
  emits: ["submit"],
  setup(__props, { emit }: { emit: ({
  (e: 'submit', form: SignApi): void
}), expose: any, slots: any, attrs: any }) {



const visible = ref(false)
const type = ref('login')
const toggle = ref(0)

const title = computed(() => {
  switch (type.value) {
    case 'login':
      return '登录'
    case 'register':
      return '注册'
    case 'forget':
      return '修改密码'
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_u_divider = _resolveComponent("u-divider")!
  const _component_u_icon = _resolveComponent("u-icon")!
  const _component_u_dialog = _resolveComponent("u-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      link: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("登录/注册")
      ]),
      _: 1
    }),
    _createVNode(_component_u_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      title: _unref(title),
      width: "320px",
      top: "30vh",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (toggle.value == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (toggle.value == 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        _createVNode(formVue, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((type).value = $event)),
          onToggle: _cache[2] || (_cache[2] = val => (toggle.value = val)),
          onSubmit: _cache[3] || (_cache[3] = form => _ctx.$emit('submit', form))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_u_divider, null, {
          default: _withCtx(() => [
            _createTextVNode("其他方式登录")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_u_icon, { name: "QQ" }),
          _createVNode(_component_u_icon, { name: "weixin" }),
          _createVNode(_component_u_icon, { name: "gitee" }),
          _createVNode(_component_u_icon, { name: "github" })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})